<div class="common-text-input__container">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-text-input__block-header">
      <label class="common-text-input__label"
        [for]="'field-type-color-'+fieldTypeColor.fieldId">
        <span class="common-text-input__text-label">{{fieldTypeColor.titleField}}</span>
        @if (field.required) {
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.description) {
            <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
          }
        </div>
      </label>
      <div class="common-text-input__buttons-right-header">
        <button class="common-color-picker__button-color"
          (click)="openColorPicker()">
          <div class="common-color-picker__inner-button-color"
            [ngStyle]="{'background': fieldTypeColor.companyColorSelected}">
            @if (fieldTypeColor.companyColorSelected === '') {
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M3 15L15 3" stroke="#D12D30" stroke-width="2" stroke-linecap="round"/>
              </svg>
            }
          </div>
        </button>
      </div>
    </div>
    <div class="common-text-input__block-input"
      [ngClass]="{'common-text-input__block-input--with-value': fieldTypeColor.companyColorSelected && !field.noEditable}">
      <input class="common-text-input__input"
        type="text"
        autocomplete="off"
        [id]="'field-type-color-'+fieldTypeColor.fieldId"
        [name]="'field-type-color-'+fieldTypeColor.fieldId"
        maxlength="7"
        [(ngModel)]="fieldTypeColor.companyColorSelected"
        [placeholder]="field.noEditable?'':fieldTypeColor.placeholder"
        [disabled]="field.noEditable"
        (blur)="blurInput()"/>
      @if (fieldTypeColor.companyColorSelected) {
        <button class="common-text-input__icon-clean-input"
          (click)="resetText()">
          <i class="lf-icon-close-thick common-icon__sm"></i>
        </button>
      }
    </div>
  </div>
  <p-colorPicker #fieldTypeColorPicker
    class="common-color-picker__container"
    styleClass="common-color-picker__square-color"
    [(ngModel)]="fieldTypeColor.companyColorSelected"
    (onChange)="changeColor($event)"/>
  @if (field.error) {
    <div class="common-text-input__mandatory-tag">
      @if (field.blocker) {
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      @if (field.errorText) {
        <span>{{field.errorText}}</span>
      }@else {
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      }
    </div>
  }
</div>
